import React, { useState, useEffect } from "react";
import { Dimmer, Loader } from "semantic-ui-react";

import Loaderr from "./components/Loader";
import Reels from "./components/Reels";
import Controls from "./components/Controls";
import $ from "jquery";
import { getGuest } from "./components/guest";
import {
    ModalHeader,
    ModalContent,
    ModalActions,
    Button,
    Modal,
    Input,
    Icon,
    Label
} from 'semantic-ui-react'
let _auth = null;
const loc = new URL(window.location);
const pathArr = loc.pathname.toString().split("/");

if (pathArr.length == 3) {
    _auth = pathArr[1] + "___" + pathArr[2];
}

//const WEB_URL = `ws://${loc.hostname}:8110/slot`;
const WEB_URL = `wss://demo.usdtpoker.club/slot`;

const r1 = [5, 1, 0, 1, 4, 2, 2, 4, 2, 0, 3, 0, 0, 3, 0, 3, 1, 1, 0, 0, 2, 1, 0, 1, 0, 2, 1, 0, 2, 0, 3, 0, 0, 5, 2, 1, 2, 1, 0, 6, 2, 1, 1, 2, 1, 2, 3, 4, 4, 6, 3, 1, 0, 3, 0, 0, 5, 0, 0, 0, 3, 1];
const r2 = [0, 4, 4, 2, 3, 0, 1, 3, 3, 1, 2, 0, 3, 0, 6, 2, 1, 0, 1, 1, 0, 1, 0, 2, 0, 0, 4, 0, 3, 0, 1, 5, 4, 1, 5, 1, 1, 2, 0, 0, 3, 0, 1, 0, 2, 0, 0, 3, 0, 2, 2, 2, 6, 0, 1, 5, 2, 2, 1, 0, 1, 3];
const r3 = [1, 3, 0, 0, 4, 4, 1, 0, 1, 2, 1, 0, 2, 0, 0, 0, 3, 6, 4, 0, 4, 0, 6, 5, 1, 0, 3, 2, 5, 3, 0, 0, 0, 1, 0, 2, 1, 1, 1, 1, 2, 0, 1, 3, 3, 0, 3, 1, 0, 0, 0, 1, 2, 2, 0, 5, 3, 1, 2, 2, 2, 2];
const rewardsList = [300, 100, 50, 20, 10, 5, 3, 2, 1];

const doCurrency = (value, sign) => {
    let val = value?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    if (sign) {
        val = parseFloat(value).toFixed(2)?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return "$" + val;
    }
    return val;
};
function animateNum() {
    $('.counter').each(function () {
        var $this = $(this),
            sign = typeof $this.attr('data-sign') == 'undefined' || $this.attr('data-sign') == 'false' ? true : false,
            countTo = parseFloat($this.attr('data-count')).toFixed(2),
            countFrom = $this.attr('start-num') ? parseFloat($this.attr('start-num')).toFixed(2) : parseFloat($this.text().replace(/,/g, "")).toFixed(2);


        if (countTo != countFrom && !$this.hasClass('doing')) {
            $this.attr('start-num', countFrom);
            // $this.addClass("doing");

            $({ countNum: countFrom }).animate({
                countNum: countTo
            },

                {

                    duration: 400,
                    easing: 'linear',

                    step: function () {
                        //$this.attr('start-num',Math.floor(this.countNum));
                        if (sign) {
                            $this.text(doCurrency(Math.abs(this.countNum), sign));
                        } else {
                            $this.text(doCurrency(Math.floor(this.countNum), sign));
                        }

                    },
                    complete: function () {
                        $this.text(doCurrency(this.countNum, sign));
                        $this.attr('start-num', parseFloat(Math.abs(this.countNum)).toFixed(2));
                        //$this.removeClass("doing");
                        //alert('finished');
                    }

                });


        } else {
            if ($this.hasClass('doing')) {
                $this.attr('start-num', countFrom);
                $this.removeClass("doing");
            } else {
                $this.attr('start-num', countFrom);
            }
        }
    });
}

function useScale(rootId = "root", scaleId = "scale", conn) {

    useEffect(() => {

        const doScale = () => {
            try {
                const root = document.getElementById(rootId);
                const scaleEl = document.getElementById(scaleId);

                if (!root || !scaleEl) return;
                const gWidth = root.clientWidth / 1400;
                const gHeight = root.clientHeight / 735;
                let scale = Math.min(gWidth, gHeight);

                if (scale > 1) scale = 1;
                // center translation to keep proportions (approximate)



                const target = 685 - gHeight;
                let t = (730 - target) / 2;
                scaleEl.style.transform = `scale(${scale}) translateY(${t}px)`;

            } catch (e) {
                // ignore
            }
        };
        window.addEventListener("resize", doScale);
        window.addEventListener("orientationchange", doScale);
        // initial

        setTimeout(doScale, 50);



        return () => {
            window.removeEventListener("resize", doScale);
            window.removeEventListener("orientationchange", doScale);
        };
    }, [conn]);

}




window.parent.postMessage("userget", "*");
let socket

const BlackjackGame = () => {
    const [userData, setUserData] = useState(null);
    const [nickname, setNickname] = useState("");
    async function connectGameWS() {
        const guest = await getGuest(WEB_URL.replace("ws://", "http://").replace("wss://", "https://").replace("/slot", ""));
        if (guest?.guestId) {
            socket = new WebSocket(WEB_URL, guest.guestId);
            socket.onopen = () => {
                console.log("WebSocket connected");
            };

            // Event onmessage baraye daryaft data az server
            socket.onmessage = (event) => {
                const data = JSON.parse(event.data); // Parse kardan JSON daryafti
                //console.log("Game data received: ", data);
                if (data.method == "spin") {
                    $("#totalwin").attr("data-count", 0);
                    animateNum();
                    $(".lines img").hide();
                    $("#dark-overlay").addClass("curplayer");
                    $("button").addClass("disabled");

                    $(".win").removeClass("win");

                    var seeds = data.reels;
                    for (var i = 1; i < 4; i++) {
                        var seed = seeds[i - 1];
                        var org = (seed - 1) * -180;
                        var _top = org - 62 * 180;

                        $(".r" + i)
                            .removeClass("freez")
                            .attr("data-help", org)
                            .css("top", "" + _top + "px");
                    }
                    getCols(seeds);
                    setTimeout(() => {
                        for (var i = 1; i < 4; i++) {
                            $(".r" + i);
                            var _top = $(".r" + i)
                                .addClass("freez")
                                .attr("data-help");

                            $(".r" + i).css("top", "" + _top + "px");
                        }

                        $("#dark-overlay").removeClass("curplayer");
                        setTimeout(() => {
                            socket.send(JSON.stringify({ method: "syncBalance" }));

                            $("button").removeClass("disabled");
                            if ($("#autospin").is(":checked")) {
                                setTimeout(() => {
                                    $(".go").trigger("click");
                                }, 4000);
                            }
                        }, 500);


                    }, 3500);
                }
                if (data.method == "connect") {
                    setConn(true);
                    setUserData(data.theClient);
                    animateNum()



                    // Update kardan state
                }
            };

            // Event onclose baraye vaghti ke websocket baste mishe
            socket.onclose = () => {
                console.log("WebSocket closed");
                setConn(false);

            };
        }
    }

    const [conn, setConn] = useState(false);
    useScale("root", "scale", conn);
    function getCols(reels) {
        var win1=0,win2=0,win3=0;
        var cols = [];
        cols.push([reels[0] - 1, reels[1] - 1, reels[2] - 1]);
        cols.push(reels);
        cols.push([reels[0] + 1, reels[1] + 1, reels[2] + 1]);
        var lines = [];
        lines.push([r1[cols[1][0]], r2[cols[1][1]], r3[cols[1][2]]]);
        lines.push([r1[cols[2][0]], r2[cols[2][1]], r3[cols[2][2]]]);
        lines.push([r1[cols[0][0]], r2[cols[0][1]], r3[cols[0][2]]]);

        lines.push([r1[cols[1][0]], r2[cols[1][1]], r3[cols[2][2]]]);
        lines.push([r1[cols[1][0]], r2[cols[1][1]], r3[cols[0][2]]]);

        lines.push([r1[cols[1][0]], r2[cols[0][1]], r3[cols[0][2]]]);
        lines.push([r1[cols[1][0]], r2[cols[2][1]], r3[cols[2][2]]]);

        lines.push([r1[cols[2][0]], r2[cols[1][1]], r3[cols[1][2]]]);
        lines.push([r1[cols[0][0]], r2[cols[1][1]], r3[cols[1][2]]]);

        lines.push([r1[cols[0][0]], r2[cols[0][1]], r3[cols[1][2]]]);
        lines.push([r1[cols[2][0]], r2[cols[2][1]], r3[cols[1][2]]]);

        lines.push([r1[cols[1][0]], r2[cols[0][1]], r3[cols[1][2]]]);
        lines.push([r1[cols[1][0]], r2[cols[2][1]], r3[cols[1][2]]]);

        lines.push([r1[cols[2][0]], r2[cols[1][1]], r3[cols[2][2]]]);
        lines.push([r1[cols[0][0]], r2[cols[1][1]], r3[cols[0][2]]]);
        var winX = 0;
        var line = $("#lineval").text();
        $('.rewardx').text('');
        lines.map(function (x, i) {
            if (i < line) {
                if (x[0] == x[1] && x[1] == x[2]) {
                    if (x[0] == 6) {
                        winX = winX + rewardsList[0];
                    }
                    if (x[0] == 5) {
                        winX = winX + rewardsList[1];
                    }
                    if (x[0] == 4) {
                        winX = winX + rewardsList[2];
                    }
                    if (x[0] == 3) {
                        winX = winX + rewardsList[3];
                    }
                    if (x[0] == 2) {
                        winX = winX + rewardsList[4];
                    }
                    if (x[0] == 1) {
                        winX = winX + rewardsList[5];
                    }
                    if (x[0] == 0) {
                        winX = winX + rewardsList[6];
                        win3 = win3 + 1;
                    }
                } else if (x[0] == x[1] && x[1] == 0) {
                    winX = winX + rewardsList[7];
                    win2 = win2 + 1;
                } else if (x[0] == 0) {
                    winX = winX + rewardsList[8];
                    win1 = win1 + 1;
                }
            }
        });
        setTimeout(() => {
            var bet = parseFloat($("#betval").text()).toFixed(2);
            if(win1>0){$("#reward8").text("x"+win1)}
            if(win2>0){$("#reward7").text("x"+win2)}
            if(win3>0){$("#reward6").text("x"+win3)}

            //console.log(winX);

            $("#totalwin").attr("data-count", winX * bet);
            animateNum();
            lines.map(function (x, i) {
                if (i < line) {
                    if (x[0] == x[1] && x[1] == x[2]) {
                        $(".lines").addClass("win");
                        $(".l" + (i + 1)).show();

                        $(".lr" + x[0])
                            .eq(0)
                            .addClass("win");
                    } else if (x[0] == x[1] && x[1] == 0) {
                        $(".lines").addClass("win");
                        $(".l" + (i + 1)).show();

                        $(".lr" + x[0])
                            .eq(1)
                            .addClass("win");
                    } else if (x[0] == 0) {
                        $(".lines").addClass("win");
                        $(".l" + (i + 1)).show();

                        $(".lr" + x[0])
                            .eq(2)
                            .addClass("win");
                    }
                }
            });
        }, 3700);

        //console.log(reels, cols, lines);

        // generate random number smaller than 13 then floor it to settle between 0 and 12 inclusive
        var seed = Math.floor(Math.random() * 12);
        seed = seed + 1;

        return seed;
    }
    function spin() {
        $("#totalwin").attr("data-count", 0);
        animateNum();
        $(".lines img").hide();
        $("#dark-overlay").addClass("curplayer");
        $("button").addClass("disabled");

        $(".win").removeClass("win");
        var line = $("#lineval").text();
        var bet = parseFloat($("#betval").text()).toFixed(2);
        const payLoad = {
            method: "spin",
            line: line,
            bet: bet,
        };
        try {
            socket.send(JSON.stringify(payLoad));
        } catch (error) {
            console.log(payLoad);
            
         }
    }


    const moreChips = () => {


        const payLoad = { method: "moreChips" }
        socket.send(JSON.stringify(payLoad));
    };
    const pickName = () => {

        const payLoad = { method: "pickName", nickname: nickname }
        socket.send(JSON.stringify(payLoad));
    };
    useEffect(() => {
        setTimeout(() => {
            connectGameWS();

        }, 500);
        // Event onopen baraye vaghti ke websocket baz shode
        $("body").css("background", "radial-gradient(rgb(32 32 32), rgb(239 182 29))");

        setTimeout(() => {
            $('.fload').remove()


       
        }, 1500);
        setInterval(() => {

            socket.send(JSON.stringify({ method: "ping" }));
        }, 15000);
        // Cleanup websocket dar zamane unmount kardan component
        return () => {
            // socket.close();
        };


    }, []);
    useEffect(() => {
        animateNum();

    }, [userData?.balance]);
    if (!conn || !userData) {
        // return <>hi</>
        return <Loaderr errcon={!userData ? false : true} />;

    }

    return (
        <>
            <div>
                <Modal
                    dimmer={'blurring'}
                    open={userData.balance <= 10 ? true : false}
                    size='mini'
                    basic
                >
                    <ModalHeader>Need more chips...</ModalHeader>
                    <ModalContent>
                        <Button fluid onClick={() => moreChips()} className="animate__bounceIn animate__animated " >
                            Request More Chips
                        </Button>
                    </ModalContent>

                </Modal>
                <Modal
                    dimmer={'blurring'}
                    open={userData.balance <= 0 && userData.username == "" ? true : false}
                    size='mini'
                >
                    <ModalHeader>Pick a Nickname...</ModalHeader>
                    <ModalContent>
                        <Input
                            fluid
                            value={nickname}
                            onChange={(e) => {
                                setNickname(e.target.value)
                            }}
                            icon={<Icon name='check' inverted circular link color="green" onClick={() => pickName()} />}
                            placeholder='Nickname...'
                        />

                    </ModalContent>

                </Modal>
                <div className="game-room" id="scale">
                    <div className="flex">
                        <div className="box">
                            <Controls balance={userData.balance} doCurrency={doCurrency} animateNum={animateNum} spin={spin} />
                        </div>
                        <div className="box">
                            <Reels />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlackjackGame;
